import { render, staticRenderFns } from "./ConfiguracoesGruposPraJa.vue?vue&type=template&id=6140001c&scoped=true&"
import script from "./ConfiguracoesGruposPraJa.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesGruposPraJa.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesGruposPraJa.vue?vue&type=style&index=0&id=6140001c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140001c",
  null
  
)

export default component.exports